import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';

/**
 *
 * Redirects to 404 screen if an API call returns error 404
 */
export const notFoundInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 404) {
        router.navigate([APP_ROUTES.NOT_FOUND.ROOT]);
      }
      return throwError(() => error);
    }),
  );
};
